import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function ArrowFromBottomMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M5 19h14v2H5v-2zM13 6.828l4 4 1.414-1.414L12 3 5.586 9.414 7 10.828l4-4V17h2V6.828z"  /></Svg>;
}
export default ArrowFromBottomMedium;